<script>
  import { gql } from "@apollo/client/core";
  import { _ as t } from "svelte-i18n";
  import { query } from "svelte-apollo";
  import { Title } from "t2c-components";

  import { client } from "apollo.js";

  import Notification from "./Notification.svelte";

  const ME_CLIENT_ACTIVITY_QUERY = gql`
    query {
      meClient {
        id
        notifications {
          id
          message
          type
          direction
          link
          data
          insertedAt
        }
      }
    }
  `;

  const activities = query(client, {
    query: ME_CLIENT_ACTIVITY_QUERY,
  });

  const sortLastFirst = (list) => {
    const sortedList = [...list].sort(
      (a, b) => new Date(b.insertedAt) - new Date(a.insertedAt),
    );
    return sortedList;
  };
</script>

<div class="container">
  <section class="wrapper">
    <div class="box">
      <Title title={$t("activityLogs")} />
    </div>
    <div class="box">
      {#await $activities then result}
        {#each sortLastFirst(result.data.meClient.notifications) as notification (notification.id)}
          <Notification {notification} />
        {/each}
        {#if result.data.meClient.notifications.length === 0}
          <span style="display: block; line-height: 35vh; text-align: center">
            {$t("content.noActivities")}
          </span>
        {/if}
      {/await}
    </div>
  </section>
</div>

<style>
  .container {
    width: 100%;
  }

  .wrapper {
    margin: 0 auto;
    max-width: 1020px;
  }

  .box:first-child {
    border-top: 0;
  }

  .box {
    padding-top: 24px;
    border-top: 1px solid var(--blue-color);
  }
</style>
